module.exports = __webpack_public_path__ + "img/spin_btn.769160cf.png";